const STORAGE_PREFIX = "teacherPlayground";
const CONTEXT_KEY = "teacherPlaygroundContext";

function getUserId() {
  try {
    const token = localStorage.getItem("access_token");
    if (!token) {
      return "";
    }
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload?.userId || "";
  } catch (err) {
    return "";
  }
}

function classStorageKey(classId) {
  return `${STORAGE_PREFIX}:${getUserId()}:${classId}`;
}

export function setPlaygroundContext(context) {
  localStorage.setItem(CONTEXT_KEY, JSON.stringify({
    classId: context.classId != null ? String(context.classId) : null,
    lessonId: context.lessonId != null ? String(context.lessonId) : null,
    returnPath: context.returnPath || "",
    homePath: context.homePath || "",
    className: context.className || "",
  }));
}

export function getPlaygroundContext() {
  try {
    return JSON.parse(localStorage.getItem(CONTEXT_KEY)) || {};
  } catch (err) {
    return {};
  }
}

export function updatePlaygroundLessonId(lessonId) {
  const context = getPlaygroundContext();
  context.lessonId = lessonId != null ? String(lessonId) : null;
  localStorage.setItem(CONTEXT_KEY, JSON.stringify(context));
}

export function getClassPlayground(classId) {
  if (classId == null) {
    return { lessons: {} };
  }
  try {
    return JSON.parse(localStorage.getItem(classStorageKey(classId))) || { lessons: {} };
  } catch (err) {
    return { lessons: {} };
  }
}

export function hasLessonPlaygroundData(classId, lessonId) {
  if (classId == null || lessonId == null) {
    return false;
  }
  const lesson = getLessonPlayground(classId, lessonId);
  return Boolean(lesson && Object.keys(lesson).length > 0);
}

export function clearLessonPlayground(classId, lessonId) {
  if (classId == null || lessonId == null) {
    return;
  }
  const data = getClassPlayground(classId);
  if (!data.lessons) {
    return;
  }
  delete data.lessons[String(lessonId)];
  if (Object.keys(data.lessons).length === 0) {
    localStorage.removeItem(classStorageKey(classId));
    return;
  }
  localStorage.setItem(classStorageKey(classId), JSON.stringify(data));
}

function getLessonPlayground(classId, lessonId) {
  const data = getClassPlayground(classId);
  return data.lessons?.[String(lessonId)] || {};
}

export function saveStepResponse(step, payload) {
  const { classId, lessonId } = getPlaygroundContext();
  if (!classId || !lessonId) {
    return;
  }
  const data = getClassPlayground(classId);
  const lessonKey = String(lessonId);
  data.lessons = data.lessons || {};
  data.lessons[lessonKey] = {
    ...(data.lessons[lessonKey] || {}),
    [step]: payload,
  };
  localStorage.setItem(classStorageKey(classId), JSON.stringify(data));
}

export function getStepResponse(step) {
  const { classId, lessonId } = getPlaygroundContext();
  if (!classId || !lessonId) {
    return null;
  }
  return getLessonPlayground(classId, lessonId)[step] || null;
}

export function getLocalStepApiResponse(step) {
  const saved = getStepResponse(step);
  if (!saved) {
    return Promise.resolve({ status: 200, data: [] });
  }

  let record = { ...saved };
  if (step === "explore" && record.response_jason && typeof record.response_jason !== "string") {
    record = {
      ...record,
      response_jason: JSON.stringify(record.response_jason),
    };
  }

  return Promise.resolve({ status: 200, data: [record] });
}

export function saveLocalStepApiResponse(step, payload) {
  saveStepResponse(step, payload);
  return Promise.resolve({ status: 200 });
}

export function mergeLocalExploreIntoInfoResponse(response) {
  const saved = getStepResponse("explore");
  if (!saved?.response_jason || !response?.data) {
    return response;
  }

  try {
    const jason = typeof saved.response_jason === "string"
      ? JSON.parse(saved.response_jason)
      : saved.response_jason;

    return {
      ...response,
      data: {
        ...response.data,
        exploreStepResponses: [{
          response_jason: jason,
        }],
      },
    };
  } catch (err) {
    return response;
  }
}

export function goToPlaygroundLessons() {
  const context = getPlaygroundContext();
  const origin = window.location.href.split("#")[0];
  if (context.returnPath) {
    window.open(`${origin}#${context.returnPath}`, "_self");
    return;
  }
  if (context.homePath) {
    window.open(`${origin}#${context.homePath}`, "_self");
    return;
  }
  window.open(origin, "_self");
}
